// https://github.com/nuxt/nuxt/issues/14766
const assets = import.meta.glob<any>('~/assets/{icons,images}/**/*', {
  import: 'default',
})
import.meta.glob<any>('~/assets/styles/**/*.scss', {
  eager: true,
})
export function useAsset(path: ComputedRef<string>): any {
  return computed(() => {
    const asset = assets[`/assets/${path.value}`]
    if (!asset) return null
    return path.value.endsWith('.svg') ? defineAsyncComponent(asset) : asset
  })
}
